import { Link } from 'react-router-dom';
import { shortenDescription } from '../utils/common';
import SensorItemHoc from '../hoc/SensorItemHoc';
import { boards } from '../utils/constants';
import EspWebInstallButton from '../EspWebInstallButton';

const descriptionLength = 350;

const BinaryOverview = ({id,
  imageUrl,
  name,
  description,
  company,
  detailsPageUrl,
  PathToManifest,
}) => {
  return (
    <>
      <div id={id} className='card mb-3 shadow-none border'>
        <div className='row g-0'>
          <Link to={detailsPageUrl} className='col-md-4'>
            <img
              src={imageUrl}
              className='img-fluid rounded-start w-100'
              style={{ maxWidth: '300px' }}
              alt={name}
            />
          </Link>
          <div className='col-md-8'>
            <div className='card-body'>
              <h4 className='card-title ms-0'>
                <Link to={detailsPageUrl} title={id}>
                  <i className='bi bi-link pe-3 text-success fs-5'></i>
                  {name}
                </Link>
              </h4>
              <p className='card-text ms-0'>
                {shortenDescription({ description, descriptionLength })}
              </p>

              <div className='d-flex align-items-center justify-content-between px-2'>
                {(company?.name && (
                  <h6
                    className='card-title d-none d-sm-block'
                    style={{ fontSize: '0.8em' }}
                  >
                    Company{' '}
                    <span style={{ fontSize: '0.9em' }}>| {company?.name}</span>
                  </h6>
                )) || <div>&nbsp;</div>}

                <div
                  className='btn-group align-items-center bg-info'
                  role='group'
                  aria-label='Basic mixed styles example'
                >
                  {
                    <EspWebInstallButton
                      label='Install'
                      PathToManifest={PathToManifest}
                      detailsPageUrl={detailsPageUrl}
                      classNames='btn-sm'
                    />
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const C3MiniBoard = SensorItemHoc(BinaryOverview, boards.C3_MINI);
const D1MiniBoard = SensorItemHoc(BinaryOverview, boards.D1_MINI);
const ESP32MiniBoard = SensorItemHoc(BinaryOverview, boards.ESP32_MINI);

export { C3MiniBoard, D1MiniBoard, ESP32MiniBoard };
